export class ProfileItem {
    description: string;
    categoryDescription: string;
    sequence: number;
    critical: boolean;
    show: boolean;
    buildToQty: number;
    uom: string;
    customerItemId: number;
    ledgerCode: number;
    locationIds: number;
    inventoryFrequency: number;
    categoryId: number;
    maxQty: number;
    customerItem: number;
    hasError: boolean;
    updated: boolean;
    categoryItemAdd: boolean;
    categoryItemRemove: boolean;
    documentType: string;
}
